module.exports = __webpack_public_path__ + "img/sarpa-logo.5e2225c8.png";